import { useEffect, useRef, useState } from "react";
import { Check, ChevronDown, Plus, X } from "lucide-react";
import api from "../lib/api";
import { notify } from "../lib/toast";
import { useAuth } from "../context/AuthContext";

export default function CompanySwitcher() {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const load = async () => {
    try {
      const r = await api.get("/companies");
      setCompanies(r.data);
    } catch {
      // ignore
    }
  };

  useEffect(() => {
    if (open) load();
  }, [open]);

  const switchTo = async (c) => {
    if (c.id === user?.company_id) {
      setOpen(false);
      return;
    }
    setLoading(true);
    try {
      await api.post(`/companies/${c.id}/switch`);
      await refresh();
      notify.success(`${c.name} çalışma alanına geçildi`);
      setOpen(false);
      window.location.reload();
    } catch (e) {
      notify.error("Şirket değiştirilemedi");
    } finally {
      setLoading(false);
    }
  };

  const createCompany = async () => {
    if (!name.trim()) return;
    setLoading(true);
    try {
      const r = await api.post("/companies", { name: name.trim() });
      await api.post(`/companies/${r.data.id}/switch`);
      await refresh();
      notify.success(`${r.data.name} oluşturuldu`);
      setName("");
      setCreating(false);
      setOpen(false);
      window.location.reload();
    } catch (e) {
      notify.error("Şirket oluşturulamadı");
    } finally {
      setLoading(false);
    }
  };

  const initial = (user?.company_name || "V")[0].toUpperCase();

  return (
    <div className="cs-wrap" ref={ref}>
      <button className="company-switcher" onClick={() => setOpen(!open)} data-testid="sidebar-company-switcher">
        <div className="company-avatar">{initial}</div>
        <div>
          <small>ÇALIŞMA ALANI</small>
          <strong>{user?.company_name || "—"}</strong>
        </div>
        <ChevronDown size={15} />
      </button>

      {open ? (
        <div className="cs-popover" data-testid="company-popover">
          {creating ? (
            <div className="cs-create">
              <label>
                Şirket adı
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoFocus
                  data-testid="new-company-name-input"
                />
              </label>
              <div className="cs-create-actions">
                <button className="secondary-btn" onClick={() => setCreating(false)} data-testid="cancel-create-company">
                  <X size={14} /> Vazgeç
                </button>
                <button className="primary-btn" onClick={createCompany} disabled={loading} data-testid="save-company-button">
                  <Check size={14} /> Oluştur
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="cs-label">ŞİRKETLERİM</div>
              {companies.length === 0 ? (
                <div className="cs-empty">Yükleniyor…</div>
              ) : (
                companies.map((c) => (
                  <button
                    className={`cs-item ${c.id === user?.company_id ? "active" : ""}`}
                    key={c.id}
                    onClick={() => switchTo(c)}
                    disabled={loading}
                    data-testid={`switch-company-${c.id}`}
                  >
                    <div className="company-avatar">{c.name[0].toUpperCase()}</div>
                    <span>{c.name}</span>
                    {c.id === user?.company_id ? <Check size={14} /> : null}
                  </button>
                ))
              )}
              <div className="cs-divider" />
              <button className="cs-item add" onClick={() => setCreating(true)} data-testid="add-company-button">
                <div className="company-avatar plus"><Plus size={14} /></div>
                <span>Yeni şirket ekle</span>
              </button>
            </>
          )}
        </div>
      ) : null}
    </div>
  );
}
